import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../state/AuthContext';
import { Spinner } from './common';

/**
 * Gate for the shop's own screens. A signed-in customer who guesses the URL is
 * sent back to the menu rather than shown an error — the API refuses them too,
 * so this is only about not presenting a broken page.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const { customer, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Spinner label="Checking your access…" />;
  }

  if (!customer) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (!customer.isStaff) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
